define([
	"csi/def",
	"csi/def/ActionFactory",
	"./ActionImage"
], function(def,ActionFactory,ActionImage) {

	return ActionFactory.declare("image", ActionImage, {
		bAllowImageRef: true,

		constructor: function(xml) {
			this.m_id = "BrowseImage";
			this.setMaterialIcon("add_a_photo");
		}
	});
});